import { Component, OnInit } from '@angular/core';
import { KursanciService } from '../services/kursanci.service';
import { Grupa } from '../services/grupa';
import { Observable } from 'rxjs/Observable';
import { AngularFireList, AngularFireObject } from 'angularfire2/database';

@Component({
  selector: 'app-grupy',
  templateUrl: './grupy.component.html',
  styleUrls: ['./grupy.component.scss']
})
export class GrupyComponent implements OnInit {

  grupy$;
  grupyRef;
  isArchiv = 0;

  constructor(private kursanciService: KursanciService) { }

    ngOnInit() {
        // this.grupyValue$ = this.kursanciService.getAktywneGrupy(this.isArchiv).valueChanges()
            this.grupyRef = this.kursanciService.getAktywneGrupy(this.isArchiv);
            this.grupy$ = this.grupyRef.snapshotChanges().map(actions => {
                    return actions.map(action => {
                      const data = action.payload.val() as Grupa;
                      const key = action.payload.key;
                      return { key, ...data };
                    })
                })
                .do( res => console.log('getAktywneGrupy:', res))
                // .subscribe(kursanci => this.kursanci$ = kursanci)
            };

}



// WEBPACK FOOTER //
// ./src/app/grupy/grupy.component.ts